import { hockeyFormatter } from '@nhl/formatter-utilities';

import { statsConfigSelectors } from '../redux/ducks/config';
import defaultFilterValues from '../redux/ducks/playersAndTeams/filter/values/defaults';
import { compareFilterValues } from '../views/components/filters/utils';

import { REGULAR_SEASON_ID } from './constants';

const getDataLayer = () => {
    window.dataLayer = window.dataLayer || [];

    return window.dataLayer;
};

class AnalyticsManager {
    sendGaEvent = (category, action, data = null, labelPostfix) => {
        try {
            const currentPage = window.location.pathname.replace('/stats/', '') || 'home';
            const label = labelPostfix ? `${currentPage}-${labelPostfix}` : currentPage;

            getDataLayer().push({
                event: action,
                event_category: category,
                event_label: label,
                ...data,
            });
        } catch (err) {
            console.error('Error sending analytics', err);
        }
    };

    sendGaHomeEvent = (action, values, franchises) =>
        this.sendGaEvent('query', action, {
            dimension1: hockeyFormatter.singleSeasonFormatter(values.seasonId), // seasonFrom/To
            dimension2: values.gameTypeId === REGULAR_SEASON_ID ? 'regular season' : 'playoffs', // gameType
            dimension3: statsConfigSelectors.getFullNameFromId(franchises, values.franchiseId) || 'All Franchises', // franchise
            dimension4: '', // position
            dimension5: '', // reportName
            dimension6: 'no',
        });

    sendGaReportEvent = (action, report, filters, franchises) => {
        let timeFrame =
            report.timeFrame === 'allTime' ? report.timeFrame.toLowerCase() : `by${report.timeFrame.toLowerCase()}`;
        this.sendGaEvent('query', action, this.getReportAnalyticsData(report, filters, franchises), timeFrame);
    };

    getReportAnalyticsData = (report, filters, franchises) => {
        let analyticsObject = {
            dimension1: 'null', // seasonFrom/To
            dimension2: report.gameTypeId === REGULAR_SEASON_ID ? 'regular season' : 'playoffs', // gameType
            dimension3: statsConfigSelectors.getFullNameFromCode(franchises, report.franchiseId) || 'All Franchises', // franchise
            dimension4: report.positionCode || 'All Skaters', // position
            dimension5: report.reportName || 'null', // reportName
            dimension6: compareFilterValues(filters, defaultFilterValues) ? 'yes' : 'no',
        };

        // Season or Date From/To
        if (report.timeFrame === 'game' && !report.isDateRangeFromSeasons) {
            const [y1, m1, d1] = report.dateFrom.split('-');
            const [y2, m2, d2] = report.dateTo.split('-');
            const value = `${m1}${d1}${y1}|${m2}${d2}${y2}`;
            analyticsObject = { ...analyticsObject, dimension1: value };
        } else {
            const seasonFrom = hockeyFormatter.singleSeasonFormatter(report.seasonFrom);
            const seasonTo = hockeyFormatter.singleSeasonFormatter(report.seasonTo);
            const value = `${seasonFrom}|${seasonTo}`;
            analyticsObject = { ...analyticsObject, dimension1: value };
        }

        return analyticsObject;
    };
}

const analyticsManager = new AnalyticsManager();

export default analyticsManager;
